import React, { createContext, useContext, useState } from "react";

const UserContext = createContext(); // Create a context for user data

const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState([]);
  const [token, setToken] = useState("");
  const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);

  return (
    <UserContext.Provider
      value={{
        userData,
        setUserData,
        token,
        setToken,
        showSubscriptionPlans,
        setShowSubscriptionPlans,
      }}
    >
      {children} {/* This allows all child components to access the context */}
    </UserContext.Provider>
  );
};

export { UserContext, UserProvider };
